import { GET, setParams } from '../../_http';
import type { operations } from '@/types/schemas/api.main';
type controller = operations['BrokerAssistantRetrieveBrokerController_get'];

export type BrokerRetrieveResponse = controller['responses']['200']['content']['application/json'];
export type BrokerRetrieveQuery = controller['parameters']['query'];

export const retrieveBroker = GET('/broker-assistants/broker', setParams<BrokerRetrieveQuery>)<BrokerRetrieveResponse>;
